import React, { useContext, useState, useEffect } from 'react'

import { useHistory } from 'react-router-dom'
import Layout from '../../../components/templates/Layout'
import CustomTable from '../../../components/molecules/CustomTable'
import CustomSearch from '../../../components/molecules/CustomSearch'
import { Button } from '@mui/material'
import { useFormik } from 'formik'
import AlertContext from '../../../context/alert/alertContext'
import CommunicationContext from '../../../context/communication/communicationContext'
import SettingContext from '../../../context/setting/settingContext'
import CustomDialog from '../../../components/organisms/Dialog'
import PrimaryButton from '../../../components/atoms/PrimaryButton'
import StaticManage from './StaticManage'
import * as Yup from 'yup'
import { useLocation } from 'react-router-dom'

const StaticPages = (props) => {
    const search = useLocation().search
    const edit = new URLSearchParams(search).get('edit')
    const alertContext = useContext(AlertContext)
    const [isLoading, setIsLoading] = useState(true)
    const communicationContext = useContext(CommunicationContext)
    const settingContext = useContext(SettingContext)
    const history = useHistory()
    const { setAlert } = alertContext
    const [allData, setAllData] = useState({})

    const {
        static_pages,
        getAllStaticPages,
        responseStatus: responseStatusCommuncation,
        clearResponse: clearResponseCommuncation,
    } = communicationContext

    const {
        settingChangeStatus,
        searchTableFetch,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseSetting,
    } = settingContext

    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
    })

    const toggleFullScreenPopup = (popup, status, id) => {
        if (popup) {
            setManage({ popup, status, id })
        } else {
            setManage({ popup, status: 'new', id: 0 })
        }
    }

    const [tableBody, setTableBody] = useState([])

    const formik = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: '',
            orderby: 'id, desc',
            primaryTable: 'static_pages',
            filters: {
                active: {
                    value: '2',
                    type: 'notin',
                    field: 'sp.active',
                },
                description: {
                    value: '',
                    type: 'like',
                    field: 'sp.name',
                },
            },
        },
        onSubmit: (values) => {
            setIsLoading(true)
            searchTableFetch(values, 'static_pages')
        },
    })

    useEffect(() => {
        if (search_fetch_data) {
            if (search_fetch_data.from === 'static_pages') {
                setTableBody(
                    search_fetch_data.records.length
                        ? search_fetch_data.records
                        : []
                )
                setAllData(search_fetch_data)
                setIsLoading(false)
            }
        }
    }, [search_fetch_data])

    useEffect(() => {
        setTableBody([])
        setIsLoading(true)
        formik.values.page = 1
        formik.values.filters.description.value = ''
        searchTableFetch(formik.values, 'static_pages')
        /*  return () => {
            setTableBody([])
        }*/
    }, [])

    useEffect(() => {
        if (responseStatusCommuncation) {
            if (
                responseStatusCommuncation.from ===
                    'CommunicationStaticPages' &&
                responseStatusCommuncation.status === 'success'
            ) {
                toggleFullScreenPopup(false)
                setTableBody([])
                formik.values.page = 1
                formik.values.filters.description.value = ''
                searchTableFetch(formik.values, 'static_pages')
            }
        }
    }, [responseStatusCommuncation])

    const onClickEdit = (id, type) => {
        toggleFullScreenPopup(true, 'edit', id)
    }

    const tableValues = [
        {
            field: 'name',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Page',
        },
    ]

    if (edit) {
        tableValues.push({
            field: 'active',
            condition: true,
            conditionValue: {
                formula: {
                    key1: 'active',
                    key2: 1,
                    notation: '===',
                },
                true: {
                    type: 'text',
                    value: 'Active',
                },
                false: {
                    type: 'text',
                    value: 'Deactive',
                },
            },
            type: 'text',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Status',
        })
    }

    tableValues.push({
        field: 'action',
        type: 'button',
        clickType: 'edit',
        onclick: onClickEdit,
        sort: false,
        firstChild: false,
        disablePadding: false,
        label: 'Action',
        tooltipTitle: 'Edit static page',
    })

    const searchInfo = {
        formik,
        data: [
            {
                label: 'Page Name',
                placeholder: 'Enter page name',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'description',
                filter: true,
            },
        ],
    }

    const validationArray = Yup.object({})

    const formikSelection = useFormik({
        initialValues: {
            primaryTable: 'static_pages',
            action: '',
            id: '',
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            if (
                values.action === 'active' ||
                values.action === 'deactivate' ||
                values.action === 'delete'
            ) {
                values.active = 1
                if (values.action === 'active') {
                    values.active = 1
                } else if (
                    values.action === 'deactivate' ||
                    values.action === 'deactivated'
                ) {
                    values.active = 0
                } else if (values.action === 'delete') {
                    values.active = 2
                }
                settingChangeStatus(values)
            }
        },
    })

    const [changeStatus, setChangeStatus] = useState(false)

    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const onSelectMultiProducts = (data, action) => {
        formikSelection.values.action = action
        formikSelection.values.id = data
        if (
            action === 'active' ||
            action === 'deactivate' ||
            action === 'deactivated' ||
            action === 'delete'
        ) {
            setChangeStatus(true)
        }
    }

    const tableActions = []

    if (edit) {
        tableActions.push(
            {
                label: 'Move to De-activate',
                icon: <span className="material-icons">block</span>,
                onclick: onSelectMultiProducts,
                type: 'deactivate',
            },
            {
                label: 'Move to Activate',
                icon: <span className="material-icons">check_circle</span>,
                onclick: onSelectMultiProducts,
                type: 'active',
            },
            {
                label: 'Move to Deleted',
                icon: <span className="material-icons">cancel</span>,
                onclick: onSelectMultiProducts,
                type: 'delete',
            }
        )
    }

    useEffect(() => {
        if (responseStatusSetting) {
            if (responseStatusSetting.status === 'success') {
                if (responseStatusSetting.from === 'changeStatus') {
                    setChangeStatus(false)
                    searchTableFetch(formik.values, 'static_pages')
                }
            }
        }
    }, [responseStatusSetting])

    return (
        <Layout
            noUI={props.noUI || false}
            renderSidePanelDefault={props.renderSidePanelDefault || false}
        >
            {' '}
            <div className="dashboard staticPages">
                <CustomSearch searchInfo={searchInfo} formik={formik} />
                <div className="miscActions d-flex justify-content-between align-items-center mt-4">
                    <Button
                        id="static_add"
                        variant="outlined"
                        className="btnOutlined"
                        onClick={() => toggleFullScreenPopup(true, 'new', 0)}
                    >
                        <span className="material-icons">note_add</span>Add New
                        Static Page
                    </Button>
                </div>
                <CustomTable
                    formik={formik.values}
                    tableBody={search_fetch_data.records}
                    tableValues={tableValues}
                    tableActions={tableActions}
                    allData={allData}
                    isLoading={isLoading}
                    loadingTemplate={'table'}
                    changeTableFunction={searchTableFetch}
                    columnStorageVariable={'table_static_page_view'}
                />
            </div>
            <StaticManage data={manage} function={toggleFullScreenPopup} />
            <CustomDialog
                title={'Change status'}
                open={changeStatus}
                function={changeChangeStatus}
            >
                <h5>Are you sure you want to change the status</h5>
                <div className="actionWrapper">
                    <Button onClick={() => changeChangeStatus()}>Cancel</Button>
                    <form
                        onSubmit={formikSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton type="submit" label="Confirm" />
                    </form>
                </div>
            </CustomDialog>
        </Layout>
    )
}
export default StaticPages
